import React from 'react';
import createReactClass from 'create-react-class';
import { Link } from 'react-router-dom';
import request from '../../helpers/request';
import setViewTitle from '../../helpers/setViewTitle';
import moment from 'moment';
import purchaseSuggestionConfig from './config/purchaseSuggestionConfig';
import auth0 from '../../helpers/auth0';
import SimplePage from '../common/SimplePage';

const $ = window.$;

let PurchaseSuggestionsOverview = createReactClass({
  actions: [{title: 'Neuer Bestellvorschlag', to: '/purchasesuggestions/new', claim: 'purchasesuggestions:new'}],

  getInitialState() {
    return {
      purchaseSuggestions: [],
      documentNoFilter: null,
      dateFilter: null
    };
  },

  componentWillMount() {
    setViewTitle(this.props.title);
  },

  componentDidMount() {

    $('#dateFilter').datepicker({
      dateFormat: 'dd.mm.yy',
      prevText: '<i class="fa fa-chevron-left"></i>',
      nextText: '<i class="fa fa-chevron-right"></i>'
    });

    $('#dateFilter').change(e => {
      this.applyFilter(e);
    });

    this.reloadData();
  },

  reloadData() {
    request.get({
      url: purchaseSuggestionConfig.apiUrl,
      data: this.createFilterParams(),
      success: purchaseSuggestions => {
        if (this.isMounted()) {
          let hasClaimAccounting = auth0.hasClaim('purchasesuggestions:accounting');

          this.setState({
            purchaseSuggestions: purchaseSuggestions,
            hasClaimAccounting,
          });
        }
      }
    });
  },

  createFilterParams() {

    var dateFilterValue = this.state.dateFilter ? moment(this.state.dateFilter, 'DD.MM.YYYY').toISOString() : null;

    return {
      documentNoFilter: this.state.documentNoFilter,
      dateFilter: dateFilterValue
    };
  },

  applyFilter(e) {
    var propName = e.target.name;
    var value = e.target.value;

    var newState = {};
    newState[propName] = value;

    this.setState(newState, () => this.reloadData());
  },

  render() {
    let { hasClaimAccounting } = this.state;

    var suggestionLinks = this.state.purchaseSuggestions.map(suggestion => {
      let createdString = moment(suggestion.dateCreated).format('DD.MM.YYYY HH:mm:ss');
      let modifiedString = moment(suggestion.dateModified).format('DD.MM.YYYY HH:mm:ss');
      let status = '';
      let link = '/purchasesuggestions/' + suggestion.id;
      let showTodoIcon = false;

      if(!suggestion.isConfirmed && !suggestion.confirmationOfMayerNeeded) {
        status = 'Warte auf Genehmigung von Buchhaltung';
        if(hasClaimAccounting) {
          link = '/purchasesuggestions/accounting/' + suggestion.id;
          showTodoIcon = true;
        }
      } else if (suggestion.confirmationOfMayerNeeded) {
        status = 'Warte auf Genehmigung von Bürgermeister';
        if(suggestion.canPerformMayorConfirmation) {
          link = '/purchasesuggestions/mayor/' + suggestion.id;
          showTodoIcon = true;
        }
      }

      return (
        <tr key={suggestion.id}>
          <td><Link to={link}>{suggestion.documentNo} {showTodoIcon ? (<i className={`fa fa-exclamation-triangle text-danger`}></i>) : null}</Link></td>
          <td><Link to={link}>{modifiedString}</Link></td>
          <td><Link to={link}>{createdString}</Link></td>
          <td><Link to={link}>{status}</Link></td>
        </tr>
      );
    });

    return (
      <SimplePage title="Zu genehmigende Bestellvorschläge" icon="file-archive-o" actions={this.actions}>
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Dokument Nr</th>
                <th>Geändert am</th>
                <th>Erstellt am</th>
                <th>Status</th>
              </tr>
              <tr>
                <th className="hasinput">
                  <input type="text" name="documentNoFilter" className="form-control" placeholder="Filter..." onChange={this.applyFilter} />
                </th>
                <th className="hasinput icon-addon">
                  <input id="dateFilter" name="dateFilter" type="text" className="form-control" placeholder="Filter..." />
                  <label htmlFor="dateFilter" className="glyphicon glyphicon-calendar no-margin padding-top-15" rel="tooltip" title="" data-original-title="Filter Date"></label>
                </th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {suggestionLinks}
            </tbody>
          </table>
        </div>
      </SimplePage>
    );
  }

});

export default PurchaseSuggestionsOverview;




// WEBPACK FOOTER //
// ./src/components/purchasesuggestions/PurchaseSuggestionsOverview.js